const translations = {
  "en": {
    "Check other agents, I’ll alert you when this one finds something worth your attention.": "Check other agents, I’ll alert you when this one finds something worth your attention.",
    "New Report": "New Report",
    "No more reports": "No more reports",
    "No Smart Signals Yet": "No Smart Signals Yet"
  },
  "zh-tw": {
    "Check other agents, I’ll alert you when this one finds something worth your attention.": "查看其他 Agent，當這個 Agent 找到值得你關注的內容時，我會通知你。",
    "New Report": "最新報告",
    "No more reports": "已載入所有報告",
    "No Smart Signals Yet": "尚無智慧訊號"
  }
};

export default translations;
